import common from 'common';
import utils from 'utils';
import defaultstates from './defaultState';
let bzrTextBannedInterval;
if (LIMI_ENV === 'electron') {
  var fs = window.require('fs');
}
export default {
  //config接口数据
  saveIndexConfig(state, res) {
    state.ping_recv_timeout = res.pingRecvTimeout || 5; //新版长连接发送1后端几秒内不回复的超时时间
    state.ping_time = res.pingTime || 20000; //新版长连接发送ping值时间
    state.round_robin_interval = res.roundRobinInterval || 60; //课时列表页轮训间隔时间
    state.animation_dl_timeout = res.animationDlTimeout || 5; //加载课件题超时时间
    state.animation_req_timeout = res.animationReqTimeout || 10; //课件题用超时时间
    state.animation_req_retry = res.animationReqRetry || 3; //课件题用重试次数
    state.exp_live_timeout = res.expLiveTimeout || 20000; //门店体验课，直播延迟上限
    state.videoBg = res.videoBg;
    state.protocol_switch = res.protocolSwitch; //goIm开关
    state.entrance_status = res.entranceStatus || false; //小游戏
    state.get_livemsg_addr_num = res.getLivemsgAddrNum || 10; //长连接重连N次不成功更换地址
    state.video_replay_time = res.videoReplayTime; //回放视频误差检测
    state.domain_list_for_ping = res.domainListForPing; //设备检测域名列表
    state.send_socket_data_recall = res.sendSocketDataRecall; //ack超时补发时间
    state.video_freeze_time = res.videoFreezeTime || 3;
    state.video_freeze_last = res.videoFreezeLast || 60;
    state.count_online_time_interval = res.countOnlineTimeInterval || 60; //观看视频时长埋点
    state.api_retry_wait = res.apiRetryWait || 2; //接口请求重试延迟
    state.get_msg_time = res.getMsgTime || 4; //轮训间隔
    state.send_socket_times = res.sendSocketTimes || 1; //长连接补发次数
    state.playbackQuestionTime = res.playbackQuestionTime || 10; //回放页题目默认消失时间
    state.rankRandTimeForClient = res.rankRandTimeForClient || 4; //获取徽章接口需要随机随机延迟
    // state.fakeLive = true;
  },
  saveLogin(state, { phone }) {
    //手机号存储
    if (common.get('phone') != phone) {
      common.remove('frontTest');
      common.remove('lastCoinAllnum');
    }
    state.phone = phone;
  },
  saveLoginInfo(state, { res, userPwd }) {
    //登录成功数据存储
    state.userID = res.uid * 1;
    state.COOK = res.token;
    fs && utils.setNodeStorge('LOCAL_COOK', res.token);
    common.set('LOCAL_COOK', res.token);
    common.set('userId', res.uid);
    common.set('LOCAL_password', userPwd);
  },
  saveFirstLogin(state, firstLogin) {
    state.firstLogin = firstLogin;
  },
  //获取用户信息
  saveUserInfo(
    state,
    {
      internal_users,
      coinAllnum,
      avatar_url,
      userBadgeNum,
      realname,
      is_unread,
      headwearUrl,
      isGhost,
    },
  ) {
    state.internal_users = internal_users;
    state.coinAllnum = coinAllnum;
    state.user_photo = avatar_url;
    state.userBadgeNum = userBadgeNum;
    state.realname = realname;
    state.is_unread = is_unread;
    state.userHeadwear = headwearUrl;
    state.isGhost = isGhost;
  },
  saveClassInfo(state, res) {
    state.class_id = res.classId || '';
    state.subject = res.subject || '';
    state.isNoviceClass = res.experienceSubType == 26;
    state.grade = res.grade || '';
    state.class_name = res.name || '';
    state.class_type = res.classType || '';
  },
  saveClassType(state, res) {
    state.class_type = res;
  },
  updateBadge(state, { num }) {
    state.userBadgeNum += num;
  },
  saveTool(state, res) {
    state.gradeIndex = res.gradeIndex;
    state.lessonIndex = res.lessonIndex;
    state.subjectIndex = res.subjectIndex;
    state.classYear = res.classYear;
    state.semesterIndex = res.semesterIndex;
  },
  saveToolIndex(state, res) {
    state[res.type] = res.index == null ? 100 : res.index;
  },
  saveBaseLessonInfo(state, res) {
    //记录小班信息
    state.smallClassId = res.smallClassId || 0;
    state.connect_wheat = res.isConnectWheat || 0;
    state.barragePosition = res.pcBarragePosition || 0;
    state.smallClassType = res.smallClassType || 0;
  },
  saveComposeLessInfo(state, res) {
    state.composeLessInfo = res;
    state.showCompose = res.showCompose;
  },
  saveLessonInfo(state, res) {

    state.isSlave = res.isSlave || 0;
    state.lesson_id = res.lessonId || '';
    state.is_voice_question = res.isVoiceQuestion || 0;
    state.course_id = res.courseId || 0;
    state.video_stream_load_timeout = res.videoStreamLoadTimeout || 10;
    state.lesson_type = res.lessonType || '';
    state.lessonState = res.state || '';
    state.lessonCoin = res.coin || 0;
    state.live_video_mp4_appoint_time = res.appointTime || 0;

    state.teacher_id = res.teacherId || '';
    state.teacher_avatar_url =
      res.teacherAvatar || '/static/img/common/defaultTeacherImg.png';
    // 如果是录播课，课程播放地址用这个
    state.playbackUrl = res.hlsUrl ? res.hlsUrl : res.playbackUrl;
    state.fakeLive = res.fakeLive===1?true:false;
    console.log('saveLessonInfo(state, res)',state.fakeLive);
  },
  saveLessonInInfo(state, res) {
    state.is_typewriting = res.isTypewriting;
    state.smallClassName = res.smallClassName;
    state.voiceSoe = res.soe;
    state.apiLessonInState = 1;
    state.coinAllnum = res.sumCoin || 0;
    state.giftSwitchUniqueId = res.giftState ? res.giftUniqueId : '';
    state.lessonState = res.state;
    state.rtcRole = res.rtcRole;
    state.continuousNum = res.continuous;
    state.continuousLevel = res.level;
    // 从lesson in 移除获取fakelive 改为从lessonList获取
    // state.fakeLive = res.fakeLive;
    state.isContinuousRightSetting = res.isContinuousRightSetting;
    if (res.banned_speak == 2) {
      state.text_banned_speak = 1;
      state.banned_speak = 0;
    } else {
      state.text_banned_speak = 0;
      state.banned_speak = res.banned_speak;
    }
    this.commit('upDateBzrTextBanned', {
      time: res.classTeacherBannedSpeakStartTime,
      timeLength: res.classTeacherBannedSpeakTimeLength,
    });
    this.commit('saveVideoUrl', res.videoUrl || []);
  },
  //更新直播地址
  saveVideoUrl(state, video_url) {
    let data = state.liveVideoUrlData || {};
    let result = {};
    video_url.forEach((item) => {
      let list = {};
      item.videoUrlList &&
        item.videoUrlList.forEach((v) => {
          if (v.status == 1) list[v.type] = v;
        });
      item.list = list;
      if (item.status == 1) result[item.type] = item;
    });
    data.live_video_url_list = result;

    state.liveVideoUrlData = data;
  },
  updataVideoUrlState(
    state,
    {
      live_video_url_type,
      live_video_url_stream,
      live_video_url,
      lesson_id,
      live_video_type,
      live_video_url_sub_type,
    },
  ) {
    let data = state.liveVideoUrlData;
    data.live_video_url_type = live_video_url_type;
    data.live_video_type = live_video_type || state.live_video_type;
    data.live_video_url_stream = live_video_url_stream;
    data.live_video_url = live_video_url;
    data.live_video_url_sub_type = live_video_url_sub_type;
    data.lesson_id = lesson_id || state.lesson_id;
    state.liveVideoUrlData = data;
  },
  setLastGrade(state, grade) {
    state.lastGrade = grade;
  },
  //更新金币
  updateLessonCoin(state, num) {
    state.lessonCoin = num;
  },
  //更新总金币
  updateAllCoin(state, num) {
    state.coinAllnum = num || 0;
  },
  //发送礼物开关
  saveGiftSwitchUniqueId(state, giftSwitchUniqueId) {
    state.giftSwitchUniqueId = giftSwitchUniqueId;
  },
  savePlaybackData(state, res) {
    state.playbackData = res;
  },
  upDateServerTime(state, temServerTime) {
    if (temServerTime <= state.temServerTime) return; //当前时间小于本地时间过滤
    let time = Math.floor(window.performance.now() / 1000);
    state.temServerTime = temServerTime;
    state.temClientTime = time;
    //console.log('本地时间：',time,'服务器时间',temServerTime)
  },
  updateState(state) {
    let LOCAL_LIST = ['liveVideoUrlData'];
    for (let i = 0; i < sessionStorage.length; i++) {
      let keys = sessionStorage.key(i);
      let val = window.sessionStorage.getItem(keys);
      if (
        state[keys] !== 'undefined' &&
        state[keys] !== undefined &&
        val !== 'undefined' &&
        val !== undefined &&
        val !== 'null' &&
        val !== null
      ) {
        let value = JSON.parse(val);
        state[keys] = value;
      }
    }
    for (let i = 0; i < LOCAL_LIST.length; i++) {
      let keys = LOCAL_LIST[i];
      let val = window.localStorage.getItem(keys);
      if (
        state[keys] !== 'undefined' &&
        state[keys] !== undefined &&
        val !== 'undefined' &&
        val !== undefined &&
        val !== 'null' &&
        val !== null
      ) {
        let value = JSON.parse(val);
        state[keys] = value;
      }
    }
  },
  //存储当前用户的徽章总数
  saveUserBadgeNum(state, { total_badge }) {
    state.userBadgeNum = total_badge;
  },
  //改变用户头像
  changePhoto(state, { imagePath }) {
    state.user_photo = imagePath;
  },
  // 改变用户头饰
  changeHeadwear(state, { imagePath }) {
    state.userHeadwear = imagePath;
  },
  //保存弹幕连对等基本信息
  saveDanmuConfig(
    state,
    {
      continuousRightBaseUrl,
      imgBaseUrl,
      continuousRightConfig,
      danmuStyleList,
      myDanmuStyleId,
    },
  ) {
    state.imgBaseUrl = imgBaseUrl || '';
    state.continuousRightBaseUrl = continuousRightBaseUrl || '';
    state.continuousRightConfig = continuousRightConfig || '';
    state.danmuStyleList = danmuStyleList || '';
    state.myDanmuStyleId = myDanmuStyleId || 0;
  },
  changeDanmuFontColor(state, { color }) {
    state.myDanmuStyleId = color;
  },
  //保存是否需要更新
  saveNewVersion(state, flag) {
    state.newVersion = flag;
  },
  httpErr(state, { type, data }) {
    state.httpStatus = type;
    state.httpData = data;
  },
  //更改api进课状态
  upDateApiLessonInState(state, apiLessonInState) {
    state.apiLessonInState = apiLessonInState;
  },
  //更改ws进课状态
  upDateWsLessonInState(state, wsLessonInState) {
    state.wsLessonInState = wsLessonInState;
  },
  //更新禁言状态
  upDateBannedSpeak(state, banned_speak) {
    state.banned_speak = banned_speak;
  },
  //更新文字禁言状态
  upDateTextBannedSpeak(state, text_banned_speak) {
    state.text_banned_speak = text_banned_speak;
  },
  //更新连对状态
  upDateContinuousLevel(state, { continuousNum, continuousLevel }) {
    state.continuousNum = continuousNum;
    state.continuousLevel = continuousLevel;
  },
  //更新班主任文字禁言状态
  upDateBzrTextBanned(state, { time, timeLength }) {
    clearTimeout(bzrTextBannedInterval);
    if (timeLength > 0) {
      state.bzr_text_banned = '1';
      let endTime = time + timeLength * 60 - common.getTemServerTime();
      bzrTextBannedInterval = setTimeout(() => {
        state.bzr_text_banned = '0';
      }, endTime * 1000);
    } else {
      state.bzr_text_banned = '0';
    }
  },
  //更新课时状态（课时列表缓存）
  upDateLessonState(state, lessonState) {
    state.lessonState = lessonState;
  },
  resetState(state) {
    for (let x in state) {
      state[x] = defaultstates[x];
      common.removeSession(x);
    }
    common.removeSession('classListActiveIndex');
    fs && utils.removeStorge('LOCAL_COOK');
    common.remove('LOCAL_COOK');
    common.remove('LOCAL_password');
  },
  refreshNet(state, online) {
    state.online = online;
  },
  //更新sei时间戳
  updateSeiTime(state, time) {
    state.seiTime = time;
  },
  //直接进入直播页标识
  saveGoVideo(state, flag) {
    state.govideo = flag;
  },
  //保存直接进入直播页所需数据
  saveGoVideoInfo(state, res) {
    state.phone = res.phoneNum;
    state.userID = res.userId * 1;
    state.COOK = res.cook;
    state.realname = res.realName;
    state.class_id = res.classId;
    state.lesson_id = res.lessonId;
    state.course_id = res.courseId;
    state.lesson_type = res.lessonType;
    state.grade = res.grade;
    state.subject = res.subject;
    state.teacher_avatar_url = res.teacherAvatarUrl;
    state.lessonCoin = res.classCoin;
    state.is_typewriting = res.isTypeWriting;
    state.is_voice_question = res.isVoiceQuestion;
    state.user_photo = res.studentAvatarUrl;
    state.teacher_id = res.teacherId;
    state.smallClassName = res.smallClassName;
    state.smallClassId = res.smallClassId;
  },
  //下载交互课件资源
  downloadKeJianZip(state, res) {
    let urls = res || state.downloadKeJianZipUrls;
    if (!urls) return;
    state.downloadKeJianZipUrls = urls;
    var ipc = window.require('electron').ipcRenderer;
    urls.zip &&
      ipc.send('loadKeJian', {
        url: urls.zip,
      });
    urls.all_json &&
      ipc.send('loadKeJian', {
        url: urls.all_json,
      });
    urls.aids_list.forEach((item) => {
      ipc.send('loadKeJian', {
        url: item.zipUrl,
      });
    });
  },

  deviceStatus(state, res) {
    state.rtcStatus = res;
  },
  //更新语音评测题服务商
  updateVoiceSoe(state, soe) {
    state.voiceSoe = soe;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js